/**
 * General utils
 */

export default {
  sanitizeHtml(htmlString: string, allowedTags: string[]): string {
    /* 
     * Based on:
     * https://gomakethings.com/how-to-sanitize-html-strings-with-vanilla-js-to-reduce-your-risk-of-xss-attacks/
     */

    function stringToHTML() {
      let parser = new DOMParser();
      let htmlDoc = parser.parseFromString(htmlString, 'text/html');
      return htmlDoc.body || document.createElement('body');
    }

    function cleanTags(html: any) {
      let nodes = html.children;
      for (let node of nodes) {
        if(isAllowedTag(node)) {
          removeAttributes(node);
          cleanTags(node);
        } else {  
          node.parentNode.removeChild(node);
        }
      }
    }

    function isAllowedTag(ele: any) {
      return allowedTags.includes(ele.tagName.toLowerCase());
    }

    function removeAttributes(ele: any) {
      let attrs = ele.attributes;
      for (let {name, value} of attrs) {
        if (isPossiblyDangerous(name, value))
          ele.removeAttribute(name);
      }
    }

    function isPossiblyDangerous(name: any, value: any) {
      let val = value.replace(/\s+/g, '').toLowerCase();

      if (['src', 'href', 'xlink:href'].includes(name)) {
        if (val.includes('javascript:') || val.includes('data:text/html'))
          return true;
      }

      if (name.startsWith('on'))
        return true;
    }

    let html = stringToHTML();
    cleanTags(html);

    /* html = html.replace(/<.*?>/g, (i) => {
      if (allowedTags.includes(i)) {
        return i;
      } else {
        return "";
      }
    }); */

    return html.innerHTML;
  },

  getUrlParamBool(param: string | null) {
    const trueValues = ["true", "1"];

    if(param != null)
      return trueValues.includes(param.toLocaleLowerCase())

    return false;
  },

  getUrlParamNum(param: string | null) {
    const numRegex = /^\d+$/

    if(param != null) {
      if (numRegex.test(param))
        return +param;
    }
    
    return false;
  },

  getUrlParamString(param: string | null) {
    if(param != null) {
        return param;
    }
    
    return false;
  }
};